<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #shareProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="shareProductDetailsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-share-product-details-step
        [shareProductsTemplate]="shareProductAndTemplate"
      ></LOSx-share-product-details-step>
    </mat-step>

    <mat-step [stepControl]="shareProductCurrencyForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-share-product-currency-step
        [shareProductsTemplate]="shareProductAndTemplate"
      ></LOSx-share-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="shareProductTermsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-share-product-terms-step
        [shareProductsTemplate]="shareProductAndTemplate"
      ></LOSx-share-product-terms-step>
    </mat-step>

    <mat-step [stepControl]="shareProductSettingsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-share-product-settings-step
        [shareProductsTemplate]="shareProductAndTemplate"
      ></LOSx-share-product-settings-step>
    </mat-step>

    <mat-step [stepControl]="shareProductMarketPriceForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.MARKET PRICE' | translate }}</ng-template>

      <LOSx-share-product-market-price-step
        [shareProductsTemplate]="shareProductAndTemplate"
      ></LOSx-share-product-market-price-step>
    </mat-step>

    <mat-step completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-share-product-charges-step
        [shareProductsTemplate]="shareProductAndTemplate"
        [currencyCode]="shareProductCurrencyForm.get('currencyCode')"
      >
      </LOSx-share-product-charges-step>
    </mat-step>

    <mat-step [stepControl]="shareProductAccountingForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-share-product-accounting-step
        [shareProductsTemplate]="shareProductAndTemplate"
        [accountingRuleData]="accountingRuleData"
        [shareProductFormValid]="shareProductFormValidAndNotPristine"
      >
      </LOSx-share-product-accounting-step>
    </mat-step>

    @if (shareProductFormValidAndNotPristine) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-share-product-preview-step
          [shareProductsTemplate]="shareProductAndTemplate"
          [accountingRuleData]="accountingRuleData"
          [shareProduct]="shareProduct"
          [taskPermission]="'UPDATE_SHAREPRODUCT'"
          (submitEvent)="submit()"
        >
        </LOSx-share-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
